import { useCallback } from 'react';
import { useTranslate } from '@tolgee/react';

const accountLimitMin = 6;
const accountLimitMax = 16;
const accountReg = /[a-zA-Z]/;
const useAccountValidator = () => {
  const { t } = useTranslate();
  return useCallback(
    (account: string, nullable: boolean = true) => {
      let error;
      // 注册流程简化, account 可选
      if (!account || !account.trim()) {
        error = nullable ? undefined : t('validate.accountEmpty');
      } else if (account.length < accountLimitMin) {
        error = t('placeholder.account');
      } else if (account.length > accountLimitMax) {
        error = t('placeholder.account');
      } else if (account.includes('@') || !accountReg.test(account)) {
        error = t('validate.accountReg');
      }
      return error;
    },
    [t],
  );
};

export default useAccountValidator;
